import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import useLeserreporterContext from '@hooks/useLeserreporterContext'
import ControlledCheckbox from '@components/ControlledCheckbox'

const StyledAnonymousCheckbox = styled.div`
  ${({
    theme: {
      spacing: { spacing20, spacing28 },
      typography: {
        bodycopy: {
          small2: { bundledCSS: bodycopySmall2CSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    padding: ${spacing20} 0 ${spacing28} 0;
    color: ${textDefault};
    ${bodycopySmall2CSS};
  `}
`

const AnonymousCheckbox: FunctionComponent = () => {
  const {
    data: { anonymous },
    handleChange,
  } = useLeserreporterContext()
  return (
    <StyledAnonymousCheckbox>
      <label>
        <ControlledCheckbox
          name="anonymous"
          checked={anonymous}
          onChange={handleChange}
        >
          Meinen Beitrag anonym veröffentlichen (optional)
        </ControlledCheckbox>
      </label>
    </StyledAnonymousCheckbox>
  )
}

export default AnonymousCheckbox
